import { AnyAction, CombinedState, Reducer, combineReducers } from '@reduxjs/toolkit'
import billingTabDialogReducer, {
  BillingTabDialogState
} from '@dtx-company/inter-app/src/redux/slices/billingTabDialogSlice'
import demoModalReducer, {
  DemoModalState
} from '@dtx-company/inter-app/src/redux/slices/demoModalSlice'
import lockModalReducer, {
  LockModalState
} from '@dtx-company/inter-app/src/redux/slices/lockModalSlice'
import proUpgradeModalReducer, {
  ProUpgradeModalState
} from '@dtx-company/inter-app/src/redux/slices/proUpgradeModalSlice'

export const revenueCombinedReducer: Reducer<
  CombinedState<{
    proUpgradeModal: ProUpgradeModalState
    lockModal: LockModalState
    demoModal: DemoModalState
    billingTabDialog: BillingTabDialogState
  }>,
  AnyAction
> = combineReducers({
  proUpgradeModal: proUpgradeModalReducer,
  lockModal: lockModalReducer,
  demoModal: demoModalReducer,
  billingTabDialog: billingTabDialogReducer
})
